module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('nav', {
    attrs: {
      "aria-label": "Page navigation"
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [(!_vm.simple) ? _c('li', {
    staticClass: "visible-md-inline visible-lg-inline",
    class: {
      disabled: _vm.pagination.current_page == 1
    }
  }, [_c('a', {
    attrs: {
      "aria-label": "First",
      "disabled": _vm.pagination.current_page == 1,
      "title": "Primeira"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePage(1)
      }
    }
  }, [_vm._m(0)])]) : _vm._e(), _vm._v(" "), (!_vm.simple) ? _c('li', {
    staticClass: "pagination-previous",
    class: {
      disabled: _vm.pagination.current_page == 1
    }
  }, [_c('a', {
    attrs: {
      "aria-label": "Previous",
      "disabled": _vm.pagination.current_page == 1,
      "title": "Anterior"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePage(_vm.pagination.current_page - 1)
      }
    }
  }, [_vm._m(1)])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pagination.last_page), function(n) {
    return _c('li', {
      class: {
        active: n == _vm.pagination.current_page
      }
    }, [(n >= _vm.min && n <= _vm.max) ? _c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changePage(n)
        }
      }
    }, [_vm._v(_vm._s(n))]) : _vm._e()])
  }), _vm._v(" "), (!_vm.simple) ? _c('li', {
    staticClass: "pagination-next",
    class: {
      disabled: _vm.pagination.current_page == _vm.pagination.last_page
    }
  }, [_c('a', {
    attrs: {
      "aria-label": "Next",
      "title": "Próxima"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePage(_vm.pagination.current_page + 1)
      }
    }
  }, [_vm._m(2)])]) : _vm._e(), _vm._v(" "), (!_vm.simple) ? _c('li', {
    staticClass: "visible-md-inline visible-lg-inline",
    class: {
      disabled: _vm.pagination.current_page == _vm.pagination.last_page
    }
  }, [_c('a', {
    attrs: {
      "aria-label": "Last",
      "title": "Última"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePage(_vm.pagination.last_page)
      }
    }
  }, [_vm._m(3)])]) : _vm._e()], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-double-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-double-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1be72b1f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bootstrap/PaginationBootstrap.vue
// module id = 282
// module chunks = 18